require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/parse-float.js
// module id = YWHz
// module chunks = 0